import { QuestionBarDefer } from '../../../areas/QuestionBar/QuestionBarDefer';
import { GoogleAd } from './ads/GoogleAd';
import { DfpAd } from './ads/DfpAd';
import { CycleBar } from '../../../areas/CycleBar/CycleBar';
export class DeferComponents {
    QuestionBarDefer = QuestionBarDefer;
    GoogleAd = GoogleAd;
    DfpAd = DfpAd;
    CycleBar = CycleBar;
}
